import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface AuthRouteProps {
    children: React.ReactNode;
}

/**
 * 认证路由组件
 * 处理微信登录流程和页面跳转逻辑
 */
export const AuthRoute: React.FC<AuthRouteProps> = ({ children }) => {
    const { isLoading, isLoggedIn, weChatOpenId } = useAuth();
    const location = useLocation();

    // 临时调试日志
    console.log('AuthRoute Debug:', {
        isLoading,
        isLoggedIn,
        weChatOpenId,
        pathname: location.pathname,
        search: location.search
    });

    // 特别关注微信登录失败的情况
    if (weChatOpenId && !isLoggedIn && !isLoading) {
        console.log('检测到微信OpenId但未登录，可能是绑定失败');
    }



    // 正在加载认证状态
    if (isLoading) {
        return (
            <div className="flex items-center justify-center min-h-screen bg-gray-100">
                <div className="text-center">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-4"></div>
                    <p className="text-gray-600">正在验证登录状态...</p>
                </div>
            </div>
        );
    }

    // 已登录，检查是否在注册页面
    if (isLoggedIn) {
        // 如果已登录且在注册页面，跳转到首页或重定向页面
        if (location.pathname === '/register') {
            const urlParams = new URLSearchParams(location.search);
            const redirectUrl = urlParams.get('redirect');
            const targetUrl = redirectUrl ? decodeURIComponent(redirectUrl) : '/';

            console.log('用户已登录，从注册页面跳转到:', targetUrl);
            return <Navigate to={targetUrl} replace />;
        }
        return <>{children}</>;
    }

    // 如果没有微信OpenId，直接跳转到注册页面（不限制公众号访问）
    if (!weChatOpenId && location.pathname !== '/register' && location.pathname !== '/login') {
        return (
            <Navigate
                to={`/register?redirect=${encodeURIComponent(location.pathname + location.search)}`}
                replace
            />
        );
    }

    // 未登录且不在注册页面和登录页面，默认跳转到注册页面
    if (location.pathname !== '/register' && location.pathname !== '/login') {
        const currentUrl = encodeURIComponent(location.pathname + location.search);
        return (
            <Navigate
                to={`/register?weChatOpenId=${weChatOpenId}&redirect=${currentUrl}`}
                replace
            />
        );
    }

    // 在注册或登录页面，显示对应的表单
    return <>{children}</>;
};
